var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenSchooling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Open_Schooling",
    "data-name": "Open  Schooling",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#f0f2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(478 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9946",
    "data-name": "Path 9946",
    d: "M0,0H47.049V47.049H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9947",
    "data-name": "Path 9947",
    d: "M18.861,13A6.861,6.861,0,0,0,12,19.861v1.96a6.861,6.861,0,1,0,13.723,0V18.293",
    transform: "translate(11.525 12.485)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9948",
    "data-name": "Path 9948",
    d: "M11.861,13a6.861,6.861,0,0,1,6.861,6.861v1.96A6.861,6.861,0,1,1,5,21.822V18.293",
    transform: "translate(4.802 12.485)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9949",
    "data-name": "Path 9949",
    d: "M17.98,22.723A6.861,6.861,0,1,0,17.98,9H17",
    transform: "translate(16.327 8.643)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9950",
    "data-name": "Path 9950",
    d: "M25.723,15.35V9.861A6.861,6.861,0,1,0,12,9.861",
    transform: "translate(11.525 2.881)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9951",
    "data-name": "Path 9951",
    d: "M9.861,22.723A6.861,6.861,0,1,1,9.861,9h.98",
    transform: "translate(2.881 8.643)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9952",
    "data-name": "Path 9952",
    d: "M5,15.35V9.861a6.861,6.861,0,0,1,13.723,0v19.6",
    transform: "translate(4.802 2.881)",
    fill: "none",
    stroke: "#0012ad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSchooling);
export default __webpack_public_path__ + "static/media/Open-Schooling.1301fc8450a7650d21da770fd97aae32.svg";
export { ForwardRef as ReactComponent };